module.exports = __webpack_public_path__ + "static/img/img_p2_3_pic.8ebf31b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_p2_3_pic.png
// module id = oiIK
// module chunks = 1